import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { notification } from 'antd';

/**
 * Actions
 */
import { hideNotification } from 'hooks/notification';

const Notification = () => {
  const { message, type, visible } = useSelector((state) => state.notification);
  const dispatch = useDispatch();
  const lastShownRef = useRef({ message: null, type: null });

  const closeNotification = () => {
    dispatch(hideNotification());
  };

  useEffect(() => {
    if (!visible) {
      lastShownRef.current = { message: null, type: null };
      return;
    }

    const isSame =
      lastShownRef.current.message === message &&
      lastShownRef.current.type === type;
    if (isSame) return;

    lastShownRef.current = { message, type };
    notification[type]({
      message: message,
      onClose: closeNotification,
    });
  }, [visible, message, type]);

  return null;
};

export default Notification;
